<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.maintenanceNotifications.title')"
      :subtitle="$t('reports.maintenanceNotifications.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="dateFrom"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
              <span
                class="error"
                v-if="this.v$.dateFrom.$invalid && this.v$.dateFrom.$dirty"
              >
                {{ $t("reports.filter.dateFrom") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="dateTo"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
              <span
                class="error"
                v-if="this.v$.dateTo.$invalid && this.v$.dateTo.$dirty"
              >
                {{ $t("reports.filter.dateTo") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <!-- CSV Export Button -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <button
              class="cdlButton"
              @click="exportCsv"
              :disabled="!viewLoader"
            >
              <img src="@/assets/img/download.png" alt="icon" />
              {{ $t("users.downLoadCSV") }}
            </button>
          </div>
        </div>
        <!-- FINE FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <ReportTable
              :items="itemFilter"
              :loading="viewLoader"
              :empty-colspan="$IsMobile() ? 1 : 4"
            >
              <template #header>
                <tr>
                  <th>
                    {{ $t("reports.maintenanceNotifications.col.colOne") }}
                  </th>
                  <th>
                    {{ $t("reports.maintenanceNotifications.col.colTwo") }}
                  </th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.maintenanceNotifications.col.colThree") }}
                  </th>
                  <th v-if="!$IsMobile()"></th>
                </tr>
              </template>

              <template #row="{ item, index }">
                <tr :class="{ odd: index % 2 }">
                  <td>{{ item.titolo }}</td>
                  <td>{{ getDateTime(item.data_creazione, true) }}</td>
                  <td v-if="!$IsMobile()">
                    {{ getDateTime(item.data_inizio, false) }}
                  </td>
                  <td v-if="!$IsMobile()">
                    <div class="cdlButton" @click="getDetails(item.id)">
                      {{ $t("tickets.details") }}
                    </div>
                  </td>
                </tr>
              </template>

              <template #mobile="{ item, index }">
                <MobileRow
                  :key="item.id || index"
                  :cols="['titolo', 'data_inizio']"
                  :item="item"
                >
                  <template #url-label>
                    <div class="cdlButton" @click="getDetails(item.id)">
                      {{ $t("tickets.details") }}
                    </div>
                  </template>
                </MobileRow>
              </template>
            </ReportTable>
            <!--            <div>-->
            <!--              <MyLoading :viewLoader="this.viewLoader" type="" />-->
            <!--            </div>-->
          </div>
        </div>
        <br /><br />
        <Paginator
          v-if="total_page > 0"
          :total-page="total_page"
          :current-page="current_page"
          @change-page="changePage"
          @prev-page="beforePage"
          @next-page="nextPage"
        />
      </div>
    </div>

    <div id="MyModal" v-if="viewModal" style="padding-top: 50px">
      <div
        class="contentModal open success historical"
        style="width: 50%; max-height: 80vh; overflow-y: auto"
      >
        <span
          class="material-icons closeOrder"
          id="closeModalX"
          @click="ctrlModal()"
          >close</span
        >
        <div>
          <h3>{{ item.titolo }}</h3>
          <div v-html="item.testo.replace('{societa}', company)"></div>
        </div>
        <div class="contentButton">
          <button class="cdlButton" @click="ctrlModal()" style="width: 100%">
            {{ $t("reports.historical.closeModal") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#MyModal {
  .contentModal {
    width: 50%;
    max-height: 80vh;
    overflow-y: auto;
  }
  .historical {
    table {
      width: 225px;
      background-color: transparent;
      margin: 0;
      tr {
        td {
          border-bottom: 0;
          table {
            width: 225px;
          }
        }
      }
    }
  }
}
</style>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MobileRow from "@/components/Tables/MobileRow.vue";
import ReportTable from "@/components/Reports/ReportTable.vue";
import Paginator from "@/components/Paginator.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "CMaintenanceNotifications",
  components: {
    MyBanner,
    MyHeaderPage,
    Paginator,
    MobileRow,
    ReportTable,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      items: [],
      itemFilter: [],
      // For the CSV export
      isExporting: false,
      dateFrom: moment().subtract(6, "months").format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      searchString: "",
      viewModal: false,
      item: {},
      total_page: 0,
      current_page: 1,
      company: this.$i18n.locale == "it" ? "Cliente" : "Customer",
    };
  },
  methods: {
    async getList() {
      const result = await this.v$.$validate();
      if (result) {
        const self = this;
        const dateFrom = moment(this.dateFrom, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
          "YYYY-MM-DD"
        );
        const dateTo = moment(this.dateTo, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
          "YYYY-MM-DD"
        );
        this.axios
          .get(
            window.VUE_APP_MISTRA_URL +
              "front/v1/report-maintenance/?from=" +
              dateFrom +
              "&to=" +
              dateTo +
              "&page=" +
              this.current_page,
            { headers: this.he }
          )
          .then((rls) => {
            this.items = rls.data.data;
            this.total_page = rls.data.last_page;
            this.current_page = rls.data.current_page;
            console.log(this.items);
            this.itemFilter = this.items;
            this.viewLoader = true;
          })
          .catch(function (err) {
            self.viewLoader = true;
            console.log(err);
          });
      }
    },
    searchByString() {
      // Reset pagination when searching
      this.current_page = 1;

      // If server-side search is implemented
      if (this.searchString.length >= 3 || this.searchString.length === 0) {
        this.getList();
      } else {
        // Client-side filtering as fallback
        this.itemFilter = [];
        let elm = this.searchString.toLowerCase();
        this.items.forEach((item) => {
          let titolo = item.titolo
            ? item.titolo.toLowerCase().includes(elm)
            : false;
          let data_creazione = item.data_creazione
            ? item.data_creazione.toLowerCase().includes(elm)
            : false;
          let data_inizio = item.data_inizio
            ? item.data_inizio.toLowerCase().includes(elm)
            : false;
          let data_fine = item.data_fine
            ? item.data_fine.toLowerCase().includes(elm)
            : false;
          if (titolo || data_creazione || data_inizio || data_fine) {
            this.itemFilter.push(item);
          }
        });
      }
    },
    getDetails(id) {
      const self = this;
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/maintenance/?id=" +
            id,
          { headers: this.he }
        )
        .then((rls) => {
          this.item = rls.data;
          this.ctrlModal();
          this.viewLoader = true;
        })
        .catch(function (err) {
          self.viewLoader = true;
          console.log(err);
        });
    },
    ctrlModal() {
      this.viewModal = !this.viewModal;

      if (this.viewModal) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        document.getElementsByTagName("body")[0].classList.add("overflow");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("overflow");
      }
    },
    changePage(page) {
      this.current_page = parseInt(page);
      this.getList();
    },
    nextPage() {
      if (this.current_page == this.total_page) {
        return;
      }
      this.current_page = parseInt(this.current_page) + 1;
      this.getList();
    },
    beforePage() {
      if (this.current_page == 1) {
        return;
      }
      this.current_page = parseInt(this.current_page) - 1;
      this.getList();
    },
    getDateTime(myTime, seconds) {
      let time = "HH:mm";
      if (seconds) {
        time = "HH:mm:ss";
      }
      return moment(myTime).format(
        "DD/MM/YYYY " + time,
        this.$i18n.locale,
        true
      );
    },

    // Add this method for CSV export
    exportCsv() {
      this.isExporting = true;

      // Create URL with all current filter parameters
      let par = "";
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      let header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-maintenance/?from=" +
            moment(this.dateFrom, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
              "YYYY-MM-DD"
            ) +
            "&to=" +
            moment(this.dateTo, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
              "YYYY-MM-DD"
            ) +
            "&csv=true" +
            par,
          { headers: header, responseType: "blob" }
        )
        .then((response) => {
          // Create a blob URL and trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Get filename from headers or use default
          const contentDisposition = response.headers["content-disposition"];
          let filename = "maintenance_notifications_report.csv";

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }

          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExporting = false;
        })
        .catch((error) => {
          console.error("Error downloading CSV:", error);
          this.isExporting = false;
        });
    },
  },
  computed: {
    pagedItems() {
      return this.items || [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / 10); // Assuming 10 items per page
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
